import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const rewardModelComponent: ComponentDef = {
  id: 'reward-model',
  name: 'Reward Model',
  description: 'Score completions to provide a training signal for alignment.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    {
      name: 'variant',
      label: 'Scoring Method',
      type: 'select',
      default: 'bradley_terry',
      options: [
        { label: 'Bradley-Terry (pairwise)', value: 'bradley_terry' },
        { label: 'Regression', value: 'regression' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const variant = String(params.variant || 'bradley_terry');

    const g = new GraphBuilder();

    if (variant === 'bradley_terry') {
      // Bradley-Terry: pairwise preference scoring
      // P(chosen > rejected) = σ(r(x, y_w) - r(x, y_l))
      g.input('chosen', [seq_len, d_model]);
      g.input('rejected', [seq_len, d_model]);

      g.linear('transformer_chosen', 'chosen', [d_model, d_model]);
      g.linear('transformer_rejected', 'rejected', [d_model, d_model]);

      g.norm('norm_chosen', 'transformer_chosen', 'LayerNorm');
      g.norm('norm_rejected', 'transformer_rejected', 'LayerNorm');

      g.linear('score_chosen', 'norm_chosen', [d_model, 1]);
      g.linear('score_rejected', 'norm_rejected', [d_model, 1]);

      // BT loss: -log σ(r_chosen - r_rejected)
      g.add('score_diff', 'score_chosen', 'score_rejected');
      g.activation('bt_loss', 'score_diff', '-log σ(r_w - r_l)  [BT loss]');
      g.output('out', 'bt_loss');

    } else {
      // Regression: direct score regression against human annotations
      g.input('completion', [seq_len, d_model]);

      g.linear('transformer', 'completion', [d_model, d_model]);
      g.norm('norm', 'transformer', 'LayerNorm');
      g.linear('score', 'norm', [d_model, 1]);

      // MSE loss against human-annotated scores
      g.input('human_score', [1]);
      g.loss('mse_loss', 'score', 'human_score');
      g.scale('regression', 'mse_loss', 'Regression Loss');
      g.output('out', 'regression');
    }

    return g.build();
  }
};
